import React from "react"
import MonitoringDeepDiveTable from "./MonitoringDeepDiveTable"
import { icons } from "../../icons/image-container"
import { createUseStyles, useTheme } from "react-jss"
import { header } from "../../util/commonstyles"
import { ReactFlowDiagram } from "./FlowDiagram/ReactFlowDiagram"

import {
  META_DATA_KEY_MAPPER,
  MODEL_META_DATA_KEY_MAPPER,
  NOTE_TEXT,
  SCREENS_DETAILS,
} from "../../util/StaticData"
import { Box, Button } from "@mui/material"
import {
  flowDiagramAsync,
  parentNodeDataSelector,
  selectedRunDetailsSelector,
  setParentNode,
} from "./MonitorSlice"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import CustomChip from "../../components/Customchip"
import { Note } from "../../components/Note"
import { useNavigate } from "react-router-dom"

const useStyles = createUseStyles({
  header: header,
  filter: {
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "150%", // You can keep this as a string or convert it to '1.5' for 150%
    marginRight: 10,
  },
  filterValue: {
    borderRadius: "6px",
    border: "1px solid #E6ECF0",
    background: "#FFF",
    height: 26,
    color: "var(--dark-neutrals-dark, #333)",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "150%",
  },
  item: {
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "13px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "16px",
  },
  btn: {
    borderRadius: "7px",
    border: "1px solid #2FD4CF",
    color: "#2FD4CF",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    height: 26,
    width: 116,
  },
  backBtn: {
    marginLeft: "15px",
  },
  btnWrapper: {
    display: "grid",
    gridTemplateColumns: "1fr auto",
  },
  btnDisableState: {
    borderRadius: "7px",
    fontFamily: ({ theme }: any) => theme.primaryFontFamily,
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "normal",
    height: 26,
    width: 116,
    color: "gray",
    background: "lightgray",
    border: "1px solid lightgray",
    cursor: "default",
  },
})

const MonitoringDeepDive = () => {
  const dispatch = useAppDispatch()

  // Get selected node and other necessary data from Redux store
  const selectedNode = useAppSelector(parentNodeDataSelector)
  const theme: any = useTheme()
  const classes = useStyles({ theme })
  const navigate = useNavigate()
  const selectedRunId = useAppSelector(
    (store) =>
      store.monitor.pipelineRunDialog?.selectedRunDetails?.az_pipeline_run_id,
  )

  // Function to redirect to Data Metadata page with necessary params
  const redirectToDataMetaData = () => {
    if (selectedRunId) {
      navigate(
        `/${SCREENS_DETAILS.DATA_METADATA}?tab=${META_DATA_KEY_MAPPER.RDQ}&runId=${selectedRunId}&ref=monitor`,
        {
          state: {
            tab: META_DATA_KEY_MAPPER.RDQ,
            runId: selectedRunId,
            ref: "monitor",
          },
        },
      )
    }
  }

  // Function to redirect to Model Metadata page with necessary params
  const redirectToModelMetaData = () => {
    if (selectedRunId) {
      navigate(
        `/${SCREENS_DETAILS.MODEL_META_DATA}?tab=${MODEL_META_DATA_KEY_MAPPER.MAPE}&runId=${selectedRunId}&ref=monitor`,
        {
          state: {
            tab: META_DATA_KEY_MAPPER.RDQ,
            runId: selectedRunId,
            ref: "monitor",
          },
        },
      )
    }
  }
  // Get active run details from Redux store
  const activeRunDetails = useAppSelector(selectedRunDetailsSelector)

  return (
    <Box
      className="border my-2 rounded-md bg-white stroke-1 stroke-black"
      sx={{ minHeight: 351 }}
    >
      <div className="flex justify-between">
        <div className="flex justify-start items-center my-6">
          <img className="mx-4" src={icons.monitoringLoadingIcon}></img>
          <div>
            <h1 className={classes.header}>Monitoring Deep Dive</h1>
            <Note note={NOTE_TEXT.MONITORING_DEEP_DIVE}></Note>
          </div>
        </div>
      </div>

      <div className="mx-6 border stroke-primaryGrey-50 stroke-1"></div>
      <Box
        className="grid"
        sx={{ gridTemplateColumns: "1fr 1.4fr", minHeight: 335 }}
      >
        <div className="mx-5 my-2">
          <CustomChip></CustomChip>

          <MonitoringDeepDiveTable />
        </div>
        <div>
          <div
            className={
              "m-auto flex justify-end gap-3 mt-2 mr-5 " + classes.btnWrapper
            }
          >
            <Box sx={{ marginLeft: 1.2 }}>
              {selectedNode?.length ? (
                <Button
                  onClick={() => {
                    dispatch(flowDiagramAsync({ reference_pipeline: "" }))
                    dispatch(setParentNode(""))
                  }}
                  variant="text"
                  sx={{ color: "#E21824", padding: 0 }}
                >
                  Back
                </Button>
              ) : (
                ""
              )}
            </Box>
            <div className="flex gap-3">
              {/* Button to navigate to Data Metadata */}
              <button
                onClick={redirectToDataMetaData}
                className={
                  activeRunDetails?.az_pipeline_run_id
                    ? classes.btn
                    : classes.btnDisableState
                }
              >
                Data Metadata
              </button>

              {/* Button to navigate to Model Metadata */}
              <button
                onClick={redirectToModelMetaData}
                className={
                  activeRunDetails?.az_pipeline_run_id
                    ? classes.btn
                    : classes.btnDisableState
                }
              >
                Model Metadata
              </button>
            </div>
          </div>
          <ReactFlowDiagram></ReactFlowDiagram>
        </div>
      </Box>
    </Box>
  )
}

export default MonitoringDeepDive
